import { IntelligentStrategy } from "./IntelligentStrategy.js";
import type { IntelligentStrategyProps } from "./IntelligentStrategyProps.js";
import { BucketPicker } from "./BucketPicker.js";
import { SequentialStrategy } from "./SequentialStrategy.js";
import type { Strategy } from "./Strategy.js";

export function createOrderStrategies(
  bucketPicker: BucketPicker,
  props: IntelligentStrategyProps,
): Strategy[] {
  return [
    new IntelligentStrategy(bucketPicker, props),
    new SequentialStrategy(),
  ];
}
